// Deterministic per-chain coloring for experimental structures (and any
// structure shown without pLDDT coloring). We use our own palette — rather
// than 3Dmol's built-in "Chain" scheme — so the legend in the settings panel
// can show the exact same colors the viewer renders.

// Brand-led, visually distinct palette. Dark blue / gold first to stay on
// theme, then a spread of hues that read clearly on a white background.
export const CHAIN_PALETTE = [
  '#173797', // brand dark blue
  '#e6b800', // darkened gold (gold #ffd700 is too light for cartoon on white)
  '#2ca02c', // green
  '#d62728', // red
  '#9467bd', // purple
  '#17a2b8', // teal
  '#ff7f0e', // orange
  '#8c564b', // brown
  '#e377c2', // pink
  '#7f7f7f', // grey
  '#1f9e89', // sea green
  '#bcbd22', // olive
];

// Single-letter chain ids map to sequential palette entries (A,B,C…), so chains
// only collide on a shared color once there are more chains than palette slots.
export function chainColor(chain) {
  if (!chain) return '#808080';
  let h = 0;
  for (let i = 0; i < chain.length; i++) {
    h = (h * 31 + chain.charCodeAt(i)) >>> 0;
  }
  return CHAIN_PALETTE[h % CHAIN_PALETTE.length];
}

export const chainColorFunc = (atom) => chainColor(atom?.chain);
